var _style, _g, _desc, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55,32.2l-0.5-2c-0.2-0.9-1-1.6-2-1.6h-2.4l-1-2l-1.2-2.3c-0.8-1.5-2.3-2.5-4.1-2.5h-2L41,19.4 C40.8,18.6,40,18,39.1,18h-8.2c-0.9,0-1.7,0.6-1.9,1.4l-0.8,2.3h-2c-1.7,0-3.3,1-4.1,2.5l-2.2,4.4h-2.4c-1,0-1.8,0.7-2,1.6l-0.5,2 c-0.1,0.4,0,0.9,0.3,1.2c0.3,0.3,0.7,0.5,1.1,0.5H18l-0.2,0.5c-0.3,0.8-0.5,1.7-0.5,2.5v6.1c0,0.5,0,1,0.1,1.4l0.5,2.3v3.8 c0,0.8,0.6,1.4,1.4,1.4h6.2c0.8,0,1.4-0.6,1.4-1.4v-2.3h15.9v2.3c0,0.8,0.6,1.4,1.4,1.4h4.7h1.5c0.8,0,1.4-0.6,1.4-1.4v-3.8 l0.5-2.3c0.1-0.5,0.1-1,0.1-1.4V37c0-0.9-0.2-1.7-0.5-2.5L52,34h1.6c0.4,0,0.8-0.2,1.1-0.5C55,33.1,55.1,32.6,55,32.2z M30.5,19.9 c0.1-0.2,0.2-0.3,0.4-0.3h8.2c0.2,0,0.4,0.1,0.4,0.3l0.6,1.8H29.9L30.5,19.9z M50.8,32.4c-0.3,0-0.5,0.1-0.7,0.3s-0.2,0.5-0.1,0.7 l0.6,1.6c0.2,0.6,0.4,1.3,0.4,1.9v6.1c0,0.4,0,0.7-0.1,1.1l-0.5,2.4c0,0.1,0,0.1,0,0.2v3.7h-1.3h-4.5v-2.1H45h1.2 c0.3,0,0.6-0.1,0.7-0.4s0.2-0.6,0-0.8c-0.2-0.3-0.4-0.4-0.7-0.4H45h-1.2H26.3h-0.6h-1.9c-0.4,0-0.8,0.4-0.8,0.8s0.3,0.8,0.8,0.8 h1.7v2.1h-5.9v-3.7c0-0.1,0-0.1,0-0.2l-0.5-2.4C19,43.9,19,43.5,19,43.1V37c0-0.7,0.1-1.3,0.4-1.9l0.6-1.6c0.1-0.2,0.1-0.5-0.1-0.7 c-0.2-0.2-0.4-0.3-0.7-0.3h-2.5l0.4-1.8c0-0.2,0.2-0.3,0.4-0.3h2.9c0.3,0,0.6-0.2,0.7-0.4l2.4-4.8c0.5-1,1.5-1.6,2.6-1.6h2.5 c0,0,0,0,0,0h12.5h0h2.6c1.1,0,2.1,0.6,2.6,1.6l2.4,4.8c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.3,0.2,0.5,0.2h2.9 c0.2,0,0.4,0.1,0.4,0.3l0.4,1.8H50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.1,38h-3.9l0.3-0.6c0.1-0.3,0.1-0.6,0-0.8c-0.2-0.2-0.4-0.4-0.7-0.4c-0.3,0-0.5,0.2-0.7,0.4l-0.9,1.8 c-0.1,0.2-0.1,0.5,0,0.8c0.1,0.2,0.4,0.4,0.7,0.4h5.2c0.4,0,0.8-0.4,0.8-0.8S48.5,38,48.1,38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.9,36.7c-0.1-0.3-0.4-0.4-0.7-0.4c-0.3,0-0.6,0.1-0.7,0.4c-0.2,0.2-0.2,0.5,0,0.8l0.3,0.6h-3.9 c-0.4,0-0.8,0.4-0.8,0.8s0.3,0.8,0.8,0.8h5.2c0.3,0,0.5-0.1,0.7-0.4c0.1-0.2,0.2-0.5,0-0.8L26.9,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,42.3H30c-0.3,0-0.6,0.1-0.7,0.4s-0.2,0.6,0,0.8s0.4,0.4,0.7,0.4h10c0.3,0,0.6-0.1,0.7-0.4s0.2-0.6,0-0.8 S40.3,42.3,40,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.4,32.1h21.2h0c0.3,0,0.6-0.1,0.7-0.4s0.2-0.6,0-0.8s-0.4-0.4-0.7-0.4H24.4c-0.4,0-0.8,0.4-0.8,0.8 S24,32.1,24.4,32.1z"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "other - services") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(17.000000, 11.016480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.694777, 0.913268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.c2805cb7.svg";
export { ForwardRef as ReactComponent };